export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://gitaseva.org").replace(
  /\/+$/,
  ""
);

export const DEFAULT_SEO_TITLE = "Gita Seva";
export const DEFAULT_SEO_DESCRIPTION =
  "A unique collection of Legends E-Books, Audios, Discourses, Articles and Divine Quotes.";
export const DEFAULT_SEO_KEYWORDS =
  "Legends E-Books, Audios, Discourses, Articles, Divine Quotes";
export const DEFAULT_SEO_PUBLISHER = "Gita Seva";

export const DEFAULT_ROBOTS = "index,follow";

/** Meta / Facebook App ID used for og: fb:app_id */
export const FB_APP_ID = (process.env.REACT_APP_FB_APP_ID || "").trim();

/**
 * Returns true when building for a UAT / dev environment.
 * Driven by REACT_APP_IS_UAT which is frozen at compile time by webpack,
 * so react-snap running on localhost during the SEO build cannot accidentally
 * flip this to true and bake noindex into production pre-rendered HTML.
 *
 * Set REACT_APP_IS_UAT=false  in .env.staging  (production build)
 * Set REACT_APP_IS_UAT=true   in .env.development (UAT / local dev build)
 */
export const isUatEnvironment = (): boolean => {
  return process.env.REACT_APP_IS_UAT === "true";
};

export const getDefaultRobots = (): string => {
  return isUatEnvironment() ? "noindex,nofollow" : DEFAULT_ROBOTS;
};

export const absoluteUrl = (path?: string) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;

  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
};

export const absoluteImage = (url?: string) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;

  const mediaBase = (process.env.REACT_APP_MEDIA_URL || "").replace(/\/+$/, "");
  if (mediaBase) {
    if (url.startsWith("/")) return `${mediaBase}${url}`;
    return `${mediaBase}/${url}`;
  }

  if (url.startsWith("/")) return `${SITE_URL}${url}`;
  return `${SITE_URL}/${url}`;
};

// Basic HTML -> text cleaning for meta descriptions / keywords.
export const stripHtml = (html?: string) => {
  if (!html) return "";

  return String(html)
    .replace(/&nbsp;/gi, " ")
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, " ")
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, " ")
    .replace(/<\/?[^>]+(>|$)/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

